export default __webpack_public_path__ + "static/media/sofa-presik2.7a70bf37.webp";